<template>
  <div class="card-discipline" @click="visualizarDisciplina">
    <div class="card-image">
      <a class="btn-fav" :class="{ active: isFavorited }" @click="toggleFavorite" title="Adicionar aos favoritos">
        <i :class="isFavorited ? 'fa-solid fa-heart' : 'fa-regular fa-heart'"></i>
      </a>
      <a v-if="!hideCart" class="btn-cart" @click="addToCart" title="Adicionar ao carrinho">
        <i class="fa fa-cart-plus icon"></i>
      </a>
      <img class="img-default" :src="coverImage" />
      <img class="img-hover" :src="hoverImage" />
      <div v-if="!hidePrice" class="hover-overlay">
        <p class="price-discipline">A partir de R$ {{ displayPrice }}</p>
      </div>
    </div>

    <div class="card-content">
      <h3 class="card-title">
        {{ discipline.nome_disciplina }}
      </h3>
    </div>

  </div>
</template>

<style scoped src="../styles/CardDiscipline.css" />

<script>
import { getLowestPrice, formatPrice, getAdminPrices } from '@/utils/pricing';
import { getCategorySlug } from '@/utils/categories';

export default {
  name: "CardDiscipline",
  props: {
    discipline: {
      type: Object,
      required: true,
    },
    hidePrice: {
      type: Boolean,
      default: false
    },
    hideCart: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFavorited: false,
      categorySlug: null
    };
  },
  computed: {
    coverImage() {
      if (this.categorySlug) {
        try {
          return require(`@/assets/background/capa-padrao-${this.categorySlug}.png`);
        } catch (e) {
          // fall through to default
        }
      }
      return require('@/assets/background/capa-padrao.png');
    },
    hoverImage() {
      if (this.categorySlug) {
        try {
          return require(`@/assets/background/capa-hover-${this.categorySlug}.png`);
        } catch (e) {
          // fall through to default
        }
      }
      return require('@/assets/background/capa-hover.png');
    },
    displayPrice() {
      return formatPrice(getLowestPrice());
    }
  },
  async mounted() {
    if (this.discipline && this.discipline.codigo_grupo) {
      this.categorySlug = await getCategorySlug(this.discipline.codigo_grupo);
    }
  },
  methods: {
    toggleFavorite(event) {
      event.stopPropagation();
      this.isFavorited = !this.isFavorited;
    },

    visualizarDisciplina() {
      this.$router.push({
        path: "/content",
        query: {
          codigo: this.discipline.codigo_disciplina,
          nome: this.discipline.nome_disciplina,
        },
      });
    },

    addToCart(event) {
      event.stopPropagation();
      if (!this.hideCart) {
        const item = {
          ...this.discipline,
          preco: getAdminPrices().combo_vip,
          isPacote: true,
          tipo: 'pacote-completo'
        };
        this.$emit("add-to-cart", item);
      }
    },
  },
};
</script>